import { useContext } from 'react'

import { createSharedContext } from '@twistopayments/design-system/utils'

/**
 * Context
 */

type Props = {
  registerCheckbox: (field: string) => void
}

export const CheckboxGroupContext = createSharedContext<Props | null>('components/molecules/checkbox/checkbox-group/checkbox-group.context#0', null)

/**
 * Hook
 */

export const useCheckboxGroupControl = () => useContext(CheckboxGroupContext)
